/*
 * $Id:: authenticationSlice.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { createSlice } from '@reduxjs/toolkit';

import { SLICE_NAME } from './constants';

export const slice = createSlice({
    name: SLICE_NAME,
    initialState: {
        me: null,
        credentials: null,
        registration: null,
        loading: false,
        error: false,
        resetAccount: null,
        resetPasswd: null,
        response: null,
    },
    reducers: {
        me: (state, action) => {
            state.me = action.payload;
        },
        authLogout: (state, action) => {
            state.auth = action.payload;
        },
        resetAccount: (state, action) => {
            state.resetAccount = action.payload;
        },
        resetPasswd: (state, action) => {
            state.resetPasswd = action.payload;
        },
        credentials: (state, action) => {
            state.credentials = action.payload;
        },
        registration: (state, action) => {
            state.registration = action.payload;
        },
        loading: (state, action) => {
            state.loading = action.payload;
        },
        error: (state, action) => {
            state.error = action.payload;
        },
        response: (state, action) => {
            state.response = action.payload;
        },
    },
});

export const me = (state) => state[SLICE_NAME].me;
export const authFail = (state) => state[SLICE_NAME].authFail;
export const authLogout = (state) => state[SLICE_NAME].authLogout;
export const resetAccount = (state) => state[SLICE_NAME].resetAccount;
export const resetPasswd = (state) => state[SLICE_NAME].resetPasswd;
export const registration = (state) => state[SLICE_NAME].registration;
export const credentials = (state) => state[SLICE_NAME].credentials;
export const loading = (state) => state[SLICE_NAME].loading;
export const error = (state) => state[SLICE_NAME].error;
export const response = (state) => state[SLICE_NAME].response;
export default slice.reducer;
